import { useTranslation } from 'react-i18next';

export const keyPrefix = 'find_similar_dropdown';
export const useFindSimilarDropdownTranslation = () => useTranslation('features', { keyPrefix });

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    find_similar: 'Найти схожие',
    events: 'События',
    faces: 'Лица',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    find_similar: 'Find similar',
    events: 'Events',
    faces: 'Faces',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    find_similar: 'Buscar semelhantes',
    events: 'Eventos',
    faces: 'Rostos',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    find_similar: 'Buscar similares',
    events: 'Eventos',
    faces: 'Caras',
  },
}) : {}) as Record<string, unknown>;
